<template>
    <AonCoverLoading
        class="error-alignment"
        :loading="typeof moat2ProductStore.productAlignmentError === 'string' ? true : false"
        :show-spinner="false"
        :title="`No Products Found for ${entityStore.entity?.name}`"
        :message="moat2ProductStore.productAlignmentErrorMsg"
    >
        <template #header>
            <font-awesome-icon
                :icon="`fas fa-triangle-exclamation`"
                class="error-alignment__icon text-warning bg-warning-light p-lg rounded-full"
                size="2xl"
            />
        </template>
        <template #footer>
            <ul class="error-alignment__suggestions my-lg list-style-disc">
                <li class="error-alignment__suggestion-item my-sm">
                    Select another company in the same hierarchy, such as a parent or subsidiary
                    that may be better known.
                </li>
                <li class="error-alignment__suggestion-item my-sm">
                    Choose a similar company, such as a competitor.
                </li>
                <li class="error-alignment__suggestion-item my-sm">
                    Build an arena using relevant technology areas.
                </li>
            </ul>
            <p class="error-alignment__support-text">
                If you need further assistance, please contact
                <a href="mailto:support@moatmetrics.com" class="text-link"
                    >support@moatmetrics.com</a
                >
            </p>
            <div class="error-alignment__actions mt-xl w-100 display-flex justify-center">
                <AonButton
                    class="error-alignment__button error-alignment__button--rerun mr-xl"
                    :label="t('productAlignment.error.rerun')"
                    type="subtle"
                    @clicked="getProductAlignment()"
                />
                <AonButton
                    class="error-alignment__button error-alignment__button--find"
                    :label="t('productAlignment.error.findLatestRun')"
                    @clicked="getPreviousRun(true)"
                />
            </div>
        </template>
    </AonCoverLoading>
</template>

<script setup>
import { onMounted, inject, ref } from 'vue'
import { useEntityStore, useMoat2ProductStore } from '@/stores'
import { useI18n } from 'vue-i18n'

const entityStore = useEntityStore()
const moat2ProductStore = useMoat2ProductStore()

const logger = inject('logger')
const { t } = useI18n()

const emit = defineEmits(['get-product-alignment', 'get-previous-run'])

const getProductAlignment = () => {
    emit('get-product-alignment')
}
const getPreviousRun = (requestNew) => {
    emit('get-previous-run')
}
</script>

<style lang="scss" scoped>
.error-alignment {
    &__icon {
        color: var(--warning);
        background-color: var(--warning-light);
    }

    &__suggestions {
        margin-top: var(--spacing-lg);
        margin-bottom: var(--spacing-lg);
    }

    &__suggestion-item {
        margin-top: var(--spacing-sm);
        margin-bottom: var(--spacing-sm);
        color: var(--text-secondary);
    }

    &__support-text {
        font-size: var(--font-size-sm);
    }

    &__actions {
        margin-top: var(--spacing-xl);
    }
}
</style>
